package one.healthium.update_food_preferences.domain.models

data class FoodPreferenceItemModel(
    val id: String,
    val text: String,
    val status: FoodPreferenceStatus,
)
